import type {RootState} from 'stores/redux_store';

export const getChannelCategories = (state: RootState) => state.entities.channelCategories;
